<template>
  <div class="awaiting-processing-block">
    <MonitoringStatCardBlock
      :definition="kpiDef"
      :data="kpis"
      :urgency="urgency"
      :loading="loading"
      is-static
    />

    <MonitoringFamilyBlock
      class="awaiting-processing-block__matrix"
      :definition="matrixDef"
      :data="data"
      :urgency="urgency"
      :loading="loading"
      @drill="$emit('drill', $event)"
    >
      <p
        slot="note"
        class="awaiting-processing-block__note"
      >
        <i class="el-icon-info" />
        {{ $t('monitoringDashboard.blocks.toBeProcessed.multiFamilyNote') }}
      </p>
    </MonitoringFamilyBlock>
  </div>
</template>

<script>
  import { AWAITING_PROCESSING_KPIS } from '@/config/monitoringDashboard.config';
  import MonitoringStatCardBlock from './MonitoringStatCardBlock.vue';
  import MonitoringFamilyBlock from './MonitoringFamilyBlock.vue';

  export default {
    name: 'AwaitingProcessingBlock',
    components: { MonitoringStatCardBlock, MonitoringFamilyBlock },
    props: {
      definition: {
        type: Object,
        required: true,
      },
      data: {
        type: Array,
        default: () => [],
      },
      kpis: {
        type: Object,
        default: () => ({}),
      },
      urgency: {
        type: String,
        default: 'safe',
        validator: (v) => ['critical', 'warning', 'safe'].includes(v),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      kpiDef() {
        return {
          blockKey: this.definition.blockKey,
          titleKey: this.definition.titleKey,
          cards: AWAITING_PROCESSING_KPIS,
        };
      },
      matrixDef() {
        return {
          blockKey: this.definition.blockKey,
          titleKey: 'monitoringDashboard.blocks.toBeProcessed.matrixTitle',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .awaiting-processing-block {
    display: flex;
    flex-direction: column;
    gap: 20px;

    &__matrix {
      flex: 1 1 auto;
    }

    &__note {
      display: flex;
      align-items: center;
      gap: 6px;
      margin: 0 0 12px;
      padding: 8px 12px;
      border-radius: 8px;
      background: rgba(#6366f1, 0.1);
      border: 1px solid rgba(#6366f1, 0.25);
      color: #c7d2fe;
      font-size: 12px;

      .el-icon-info {
        font-size: 14px;
      }
    }
  }
</style>
